import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=20977588&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=20977588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20977588",
  null
  
)

export default component.exports